<template>
  <div class="acc_list_main_temp_products_list mt-5">
    <div class="row">
      <div class="col-12" :class="cardClass" v-for="accommodation in items">
        <StructuredData :accommodation="accommodation"/>

        <article>
          <div class="row">
            <div class="col-12 col-md-4 col-lg-12 col-xl-4 image-content mb-3 mb-md-0 mb-xl-0">
              <figure class="mb-0 mb-lg-3">

                <NuxtLink :to="accommodation.getLinkWithSlash()"
                          :title="`${$t('offer-detail')} - ${accommodation.title}`">
                  <img
                      :src="accommodation.hasImage() ? accommodation.getTopImage().getTyrionSrc('thumbw') : require('@/assets/img/no-image.svg')"
                      :alt="accommodation.title" :title="accommodation.title + ' ' + ( accommodation.hasImage() ? accommodation.getTopImage().title : '')"
                      loading="lazy" class="img-cover img-border"
                      :width="accommodation.getTopImage().seoWidth('thumb')" :height="accommodation.getTopImage().seoHeight('thumb')">
                </NuxtLink>

              </figure>

            </div>
            <div class="col-12 col-md-8 col-lg-12 col-xl-8 right-content">

              <NuxtLink class="text-decoration-none text-dark" :to="accommodation.getLinkWithSlash(activeLocale.code)">
                <div class="row d-flex h-100">
                  <div class="col-12 pb-3">
                    <h2 class="mb-0 h3 mt-3 mt-md-0 mt-lg-3 mt-xl-4">
                      {{ accommodation.title }}
                    </h2>
                    <small class="text-muted">{{ $t('acc-type-' + accommodation.category) }},
                      max&nbsp;{{ accommodation.max_hosts_capacity }}&nbsp;hosts</small>

                  </div>
                  <div class="content d-block d-md-flex d-lg-block d-xl-flex align-content-end mx-0 px-0 w-100">
                    <div class="col-12 col-md-8 col-lg-12 col-xl-8">
                      <div>
                        <TyIcon icon="ty-star" width="1.2rem" class="icon-color-first pb-1 me-2"/>
                        <span>
                    <strong>{{ accommodation.review_rating > 0 ? accommodation.review_rating + '/5' : '' }}</strong>
                    <span class="text-muted ms-4" v-if="accommodation.review_count > 0">
                      {{ accommodation.review_count }}&nbsp;reviews
                    </span>
                    <span class="text-muted" v-else>
                      {{ $t('no-reviews') }}
                    </span>
                  </span>
                      </div>
                      <div>
                        <TyIcon icon="ty-map-pointer" width="1.2rem" class="icon-color-first pb-1 d-inline-block"/>
                        <span class="ms-2 text-muted small" v-if="accommodation.location && accommodation.location.city">
                        {{ accommodation.location.city.title }},
                        {{ accommodation.location.street }} {{ accommodation.location.street_number }},
                        {{ accommodation.location.country ? accommodation.location.country.title : '' }}
                      </span>
                      </div>
                    </div>
                    <div class="col-12 col-md-4 col-lg-12 col-xl-4 price text-end mt-lg-3 mt-xl-0 mt-3 mt-md-0">
                      <p class="mb-0 h5 first-color d-block" v-if="accommodation.price_from > 0 && accommodation.price_from !== 9999">
                        <strong>{{ accommodation.price_from }}€</strong>&nbsp;/&nbsp;{{ $t('night') }}
                      </p>
                    </div>
                  </div>
                </div>
              </NuxtLink>
            </div>
          </div>

        </article>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import StructuredData from "../structured_data.vue";
import Accommodation from "../../../../../lib/models/Accommodation";
import {computed, PropType} from "vue";

const props = defineProps({
  accommodations: Array as PropType<Array<Accommodation>>,
  activeLocale: Object,
  cardClass: String,
})

const items = computed(() => {
  return props.accommodations.map((i) => {
    return (new Accommodation()).fromObject(i) as Accommodation
  })
});

</script>
